import React, { useState, useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from 'react-bootstrap/Dropdown';
import './coupandiscount.scss'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const Coupandiscount = () => {


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isOpen, setIsOpen] = useState(false); // State to manage dropdown visibility

    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const handleCancel = () => {
        setStartDate(null);
        setEndDate(null);
        setIsOpen(false);
    };

    const handleApply = () => {
        
        setIsOpen(false);
    };
    return (
        <>
            <section className='coupanscss'>
                <h1 className="headercoupanmain">
                    Coupons
                </h1>

                <div className="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col"> Code</th>
                                <th scope="col">Expired On</th>
                                <th scope="col">Discount</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>

                            <>
                                <tr>
                                    <td>
                                        <div className="switch-input">
                                            <input
                                                className="tgl tgl-ios"
                                                id="toggle1"
                                                type="checkbox"
                                            />
                                            <label
                                                className="tgl-btn"
                                                htmlFor="toggle1"
                                            ></label>
                                        </div>
                                    </td>


                                    <td className="innersectd">
                                        200NEW
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
                                            <path d="M6.88782 2.54321H1.2155C0.544197 2.54321 0 3.0874 0 3.75869V11.8619C0 12.5332 0.544197 13.0774 1.2155 13.0774H6.88782C7.55913 13.0774 8.10332 12.5332 8.10332 11.8619V3.75869C8.10332 3.0874 7.55913 2.54321 6.88782 2.54321Z" fill="white" />
                                            <path d="M10.5345 2.13784V10.241C10.5335 10.5631 10.4052 10.8717 10.1774 11.0994C9.94967 11.3272 9.64106 11.4555 9.31899 11.4565H8.91382V3.75848C8.91382 3.2212 8.70038 2.70593 8.32047 2.32602C7.94055 1.94611 7.42527 1.73268 6.88799 1.73268H2.50409C2.58768 1.49625 2.74236 1.29146 2.94691 1.14639C3.15146 1.00132 3.39588 0.923068 3.64666 0.922363H9.31899C9.64106 0.923325 9.94967 1.05169 10.1774 1.27943C10.4052 1.50717 10.5335 1.81577 10.5345 2.13784Z" fill="white" />
                                        </svg>

                                    </td>
                                    <td>
                                        Nov 25, 2021
                                    </td>
                                    <td>
                                        <span className="innerfourthtd">
                                            Rs200 Fixed
                                        </span>
                                        {/* <span className="innerfourthtdgreen">
                                            15%
                                        </span> */}
                                    </td>
                                    <td>
                                        <a
                                            onClick={() => {
                                                setShow(true);


                                            }}
                                        >
                                            <img
                                                src="\users-assets\edit-icon.svg"
                                                alt="img"
                                                className="img-fluid mr-2"
                                            />
                                        </a>
                                        <a
                                        // onClick={() => {
                                        //     setShow1(
                                        //         true
                                        //     );

                                        // }}
                                        >
                                            <img
                                                src="\users-assets\trash-icon.svg"
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </a>
                                    </td>















                                </tr>
                                <tr>
                                    <td>
                                        <div className="switch-input">
                                            <input
                                                className="tgl tgl-ios"
                                                id="toggle2"
                                                type="checkbox"
                                            />
                                            <label
                                                className="tgl-btn"
                                                htmlFor="toggle2"
                                            ></label>
                                        </div>
                                    </td>


                                    <td className="innersectd">
                                        200NEW
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
                                            <path d="M6.88782 2.54321H1.2155C0.544197 2.54321 0 3.0874 0 3.75869V11.8619C0 12.5332 0.544197 13.0774 1.2155 13.0774H6.88782C7.55913 13.0774 8.10332 12.5332 8.10332 11.8619V3.75869C8.10332 3.0874 7.55913 2.54321 6.88782 2.54321Z" fill="white" />
                                            <path d="M10.5345 2.13784V10.241C10.5335 10.5631 10.4052 10.8717 10.1774 11.0994C9.94967 11.3272 9.64106 11.4555 9.31899 11.4565H8.91382V3.75848C8.91382 3.2212 8.70038 2.70593 8.32047 2.32602C7.94055 1.94611 7.42527 1.73268 6.88799 1.73268H2.50409C2.58768 1.49625 2.74236 1.29146 2.94691 1.14639C3.15146 1.00132 3.39588 0.923068 3.64666 0.922363H9.31899C9.64106 0.923325 9.94967 1.05169 10.1774 1.27943C10.4052 1.50717 10.5335 1.81577 10.5345 2.13784Z" fill="white" />
                                        </svg>

                                    </td>
                                    <td>
                                        Nov 25, 2021
                                    </td>
                                    <td>
                                        {/* <span className="innerfourthtd">
                                            Rs200 Fixed
                                        </span> */}
                                        <span className="innerfourthtdgreen">
                                            15%
                                        </span>
                                    </td>
                                    <td>
                                        <a
                                            onClick={() => {
                                                setShow(true);


                                            }}
                                        >
                                            <img
                                                src="\users-assets\edit-icon.svg"
                                                alt="img"
                                                className="img-fluid mr-2"
                                            />
                                        </a>
                                        <a

                                        >
                                            <img
                                                src="\users-assets\trash-icon.svg"
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </a>
                                    </td>















                                </tr>
                            </>



                        </tbody>
                    </table>
                </div>
            </section>

            <Offcanvas
                show={show}
                onHide={handleClose}
                className="dicountmainbanner"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Create Coupon</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="bannerss">
                        <h4>Code</h4>
                        <div className="filedinput">
                            <input
                                type="text"
                                placeholder="Title"


                            />
                        </div>
                        <h4>Discount</h4>
                        <div className="filedinput">
                            <div className="prntmaindrop">

                                <Dropdown>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        <h3 className="droptoggleh3">Type</h3>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="#/action-1"> <h3 className="dropitemh3" >Fixed</h3></Dropdown.Item>
                                        <Dropdown.Item href="#/action-2"> <h3 className="dropitemhsecnd">Percentage</h3></Dropdown.Item>

                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <input
                                type="text"
                                placeholder="Discount"


                            />
                        </div>
                        <h4>Expired On</h4>
                        <input
                            type="text"
                            placeholder="DD/MM/YY"
                            className={`calendarpsan ${isOpen ? "active" : ""}`}
                            onClick={() => setIsOpen(!isOpen)}
                        />
                        {isOpen && (
                            <div className="datepicker-dropdown">
                                <DatePicker
                                    selected={startDate}
                                    onChange={onChange}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange
                                    inline
                                />

                            </div>
                        )}



                        <div className='threebuttons'>


                            {isOpen && (
                                <div className="datepicker-dropdown">
                                    <DatePicker
                                        selected={startDate}
                                        onChange={onChange}
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        inline
                                    />


                                </div>
                            )}
                        </div>
                        <div className="buttonss">
                            <button className="btn-1" >
                                Cancel
                            </button>
                            <button className="btn-1 btn-2 btnactive" >
                                Schedule
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Coupandiscount